import { genres } from '@/mocks/dramas';

export default function Genres() {
  return (
    <section id="genres" className="scroll-mt-20 bg-[#faf6ef] py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 max-w-2xl">
          <p className="mb-2 text-xs font-bold uppercase tracking-widest text-[#e85d3f]">剧荒救星 · 分类导航</p>
          <h2 className="font-serif-sc text-2xl font-black text-[#26201a] md:text-3xl">按类型找到你想追的剧</h2>
          <p className="mt-3 text-sm leading-6 text-[#6f655a]">
            从悬疑烧脑到古装权谋，从家庭治愈到青春校园，六大剧集分类把热门与口碑好剧一次归类，快速定位你的下一部心头好。
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
          {genres.map((g) => (
            <a
              key={g.name}
              href="#guide"
              className="group relative flex flex-col overflow-hidden rounded-2xl border border-[#26201a]/8 bg-white transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative h-32 overflow-hidden sm:h-36">
                <img
                  src={g.img}
                  alt={`${g.name}连续剧`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#26201a]/70 to-transparent"></div>
                <i className={`${g.icon} absolute bottom-2.5 right-2.5 text-xl text-white/90`}></i>
              </div>
              <div className="px-3 py-3">
                <h3 className="font-serif-sc text-sm font-black text-[#26201a]">{g.name}</h3>
                <p className="mt-0.5 text-[11px] text-[#a3988a]">{g.count} 部好剧</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}